import { motion, useTransform } from "framer-motion";
import { useTranslation } from "react-i18next";


export default function Card({ project, index, total, progress, }) {
    const targetScale = 1 - (total - index - 1) * 0.05;

    const scale = useTransform(progress, [index / total, 1], [1, targetScale]);
    
    const { t } = useTranslation();

    return (
        <div className="sticky-card">
            <motion.div className={`project-card ${index % 2 === 0 ? "card-right" : "card-left"}`} style={{
                scale,
                rotate: index % 2 === 0 ? 3 : -3,
                top: `${index * 25}px`,
            }}>
                
                <div className="title-div-card">
                    <div className="icon-div-card">
                        <i className={project.icon}></i>
                    </div>
                    <div className="text-div-card">
                        <p>{project.title}</p>
                        <p>{project.date}</p>
                    </div>
                </div>

                <p className="dis-div-card">{project.description}</p>

                <div className="content-div-card">
                    <p>{t("experience-cards.KeyAchievements")}</p>
                    <ul>
                        {project.achievements.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                </div>

            </motion.div>
        </div>
    );
}